
export default function Products() {
  const navigateToPage = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  const products = [
    {
      icon: 'ri-drop-line',
      title: 'Waterproofing Solutions',
      description: 'Advanced waterproofing membranes and coatings for basements, roofs, and structural elements.',
      features: ['Liquid Membranes', 'Sheet Membranes', 'Crystalline Systems', 'Injection Resins']
    },
    {
      icon: 'ri-hammer-line',
      title: 'Concrete Repair',
      description: 'High-performance repair mortars and compounds for structural concrete restoration.',
      features: ['Structural Repair', 'Non-Shrink Grouts', 'Epoxy Mortars', 'Quick Setting']
    },
    {
      icon: 'ri-shield-line',
      title: 'Protective Coatings',
      description: 'Specialized coatings for industrial environments and harsh chemical exposure.',
      features: ['Chemical Resistance', 'Anti-Corrosive', 'Fire Retardant', 'Anti-Slip']
    },
    {
      icon: 'ri-building-line',
      title: 'Structural Adhesives',
      description: 'High-strength bonding solutions for concrete, steel, and composite materials.',
      features: ['Epoxy Adhesives', 'Structural Glazing', 'Anchor Systems', 'Joint Sealants']
    },
    {
      icon: 'ri-road-map-line',
      title: 'Flooring Systems',
      description: 'Industrial flooring solutions for warehouses, factories, and commercial spaces.',
      features: ['Epoxy Floors', 'Polyurethane', 'Anti-Static', 'Heavy Duty']
    },
    {
      icon: 'ri-palette-line',
      title: 'Protective & Decorative Coatings',
      description: 'Durable coatings designed to enhance both the aesthetics and longevity of surfaces while offering superior protection against weathering, corrosion, and chemical exposure.',
      features: ['Weather Resistance', 'Corrosion Protection', 'Chemical Resistance', 'Aesthetic Enhancement']
    }
  ];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Products
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive range of construction chemicals and materials for every project requirement
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product, index) => (
            <div key={index} className="bg-gray-50 rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
                style={{ backgroundColor: '#7E887E' }}
              >
                <i className={`${product.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {product.title}
              </h3>
              
              <p className="text-gray-600 mb-6">
                {product.description}
              </p>
              
              <ul className="space-y-2 mb-6">
                {product.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <button 
                className="w-full py-3 text-white font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                style={{ backgroundColor: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#6B756B'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#7E887E'}
              >
                Learn More
              </button>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => navigateToPage('/products')}
            className="px-8 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105"
            style={{ backgroundColor: '#7E887E' }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#6B756B'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#7E887E'}
          >
            View All Products
          </button>
        </div>
      </div>
    </section>
  );
}